<template>
  <div>
    <div class="cardCustom">
      <div class="card cardCustom__side">
        <div class="row w-full">Test</div>
        <div class="row w-full">
          <div class="col-xs-12 col-lg-12"></div>
        </div>
        <div v-if="$slots.footer">
          <hr />
          <slot name="footer"></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TotalSuggestions',
};
</script>

<style scoped></style>
